import React from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import ModalHeading from '@uikit/components/Modal/ModalHeading';
import XNeutral from '@uikit/icons/XNeutral';

import { successVoteImg } from '@shared/assets/images/scope/projectValidation';
import { getShareUrl } from '@shared/helpers/sharing';

interface VoteRegisteredStepProps {
  appId: string;
  appName: string;
  onNext: () => void;
}

const VoteRegisteredStep = ({ appName, appId, onNext }: VoteRegisteredStepProps) => {
  const shareUrl = `${process.env.NEXT_PUBLIC_HOST}/app/${appId}`;
  const twitterUrl = getShareUrl('twitter', {
    url: shareUrl,
    text: `Join me in validating ${appName} on #MagicStore! 🚀\n\n✅ Evaluate, collaborate & earn Karma points.\n\n💡 Your Karma can be future rewards!\n\nParticipate now: {{url}}`,
  });

  return (
    <>
      <ImageProxy
        className="h-[138px] w-auto mx-auto"
        src={successVoteImg}
        alt=""
        width={263}
        height={278}
      />

      <ModalHeading>Vote Registered</ModalHeading>

      <div className="flex gap-4 mt-4 flex-wrap">
        <a
          href={twitterUrl}
          target="_blank"
          rel="noreferrer"
          className="button button-outline-primary button-lg gap-2 flex-grow"
        >
          <XNeutral className="icon" />
          Share on Twitter
        </a>
      </div>

      <button
        className={classNames('button button-solid-primary button-lg w-full flex-grow ')}
        onClick={onNext}
      >
        Close
      </button>
    </>
  );
};

export default VoteRegisteredStep;
